import { Component, Input, Output, EventEmitter, AfterViewInit, OnInit, OnDestroy } from "@angular/core";

import { Eds, IEds } from "./services/Eds";
import { MedSignService } from "./med-sign.service";

@Component({
  selector: "med-sign[data]",
  templateUrl: "med-sign.component.html",
  styleUrls: [
    "med-sign.component.scss",
  ],
})
export class MedSignComponent implements AfterViewInit, OnInit, OnDestroy {
  constructor(private medSign: MedSignService) {}

  private _eds!: IEds;

  @Input() data!: string;

  @Output() sign = new EventEmitter<string>();

  ngOnInit(): void {
    this._eds = new Eds(this.medSign.signWidgetUrl, this._signData.bind(this));
  }

  ngAfterViewInit(): void {
    if (this._eds.hasWidget()) {
      return;
    }

    this._eds.loadWidget();
  }

  ngOnDestroy() {
    this._eds.destroy();
  }

  private async _signData(): Promise<void> {
    const sign = await this._eds.sign(this.data);
    this.sign.emit(sign);
  }
}
